import React, { Component } from "react";
import LayoutWrapper from "./LayoutWrapper";
import AssessSearch from "./AssessSearch";

export class AssessManagement extends Component {
  constructor(props) {
    super(props);
    if (props.initialconstruct) {
      props.initialconstruct.bind(this)("AssessManagement");
    }
    this.state = {
      role: "",
      data: [],
      academicYears: [],
      assessmentYear: "",
      rowcount: 0,
      search: { page: 1, limit: 10 },
      loader: false,
      columns: [
        {
          dataIndex: "school_name",
          title: "School Name",
          sorter: false,
          display: true,
          render: (text, record) => record.school?.school_name || "N/A"
        },
        {
          dataIndex: "class_name",
          title: "Class Name",
          sorter: false,
          render: (text, record) => <strong>{record.class?.curriculum?.curriculum_name || record.class?.name || record.class_id || "N/A"}</strong>
        },
        {
          dataIndex: "section",
          title: "Section",
          sorter: false,
          render: (text, record) => record.section?.name || record.section_id || "N/A"
        },
        {
          dataIndex: "half_yearly",
          title: "Half Yearly Available",
          sorter: false,
          render: (text, record) => record.mid_year_status?.is_report_generated ? "Yes" : "No"
        },
        {
          dataIndex: "annually",
          title: "Annually Report Available",
          sorter: false,
          render: (text, record) => record.full_year_status?.is_report_generated ? "Yes" : "No"
        },
        {
          dataIndex: "action",
          title: "Action",
          sorter: false,
          render: (text, record) => {
            return (
              <div className="dropdown dropdown-action text-end">
                <a href="#" className="action-icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="material-icons" style={{ color: '#888' }}>more_vert</i>
                </a>
                <div className="dropdown-menu dropdown-menu-right" style={{ minWidth: '150px', padding: '10px', borderRadius: '8px' }}>
                  <a
                    className="dropdown-item"
                    href="#"
                    style={{ color: '#f39c12', fontSize: '14px', padding: '5px 10px' }}
                    onClick={(e) => { e.preventDefault(); window.navigate(`/assessmanagement/vieweditscore?id=${record._id}`); }}
                  >
                    <i className="la la-pencil m-r-5" style={{ fontSize: '16px' }}></i> View/Edit Score
                  </a>
                </div>
              </div>
            );
          }
        }
      ]
    };
  }

  componentDidMount() {
    let currentAdminRole = localStorage.getItem("currentAdminRole");
    this.setState({ role: currentAdminRole });
    this.fetchAcademicYears();
  }

  fetchAcademicYears = () => {
    this.props.api
      .apiGetAcademicYears()
      .then(({ data }) => {
        if (data && data.length > 0) {
          const defaultYearId = data[0]._id;
          this.setState(
            { academicYears: data, assessmentYear: defaultYearId },
            () => this.fetchList()
          );
        }
      })
      .catch(() => {});
  };

  fetchList = (searchData = {}) => {
    this.setState({ loader: true });
    
    let payload = {
      ...this.state.search,
      ...searchData,
      academic_year_id: this.state.assessmentYear
    };
    
    let cleanPayload = {};
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined && payload[key] !== null && payload[key] !== "") {
        cleanPayload[key] = payload[key];
      }
    });
    
    if (this.state.role === "SCHOOL_ADMIN") {
      cleanPayload.school_id = localStorage.getItem("school_admin_id");
    } else if (this.state.role === "SCHOOL_COORDINATOR") {
      cleanPayload.school_id = localStorage.getItem("school_id");
    }

    this.props.api
      .apiGetOfflineAssessmentSections(cleanPayload)
      .then((res) => {
        this.setState({
          data: res.data,
          rowcount: res.total,
          loader: false
        });
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  };

  onSearch = (searchData) => {
    this.setState(
      { search: { ...this.state.search, ...searchData, page: 1 } },
      () => this.fetchList()
    );
  };

  onPageChange = (pageData) => {
    this.setState(
      {
        search: {
          ...this.state.search,
          page: pageData.current,
          limit: pageData.pageSize || 10
        }
      },
      () => this.fetchList()
    );
  };



  render() {
    let { data, assessmentYear, academicYears, rowcount, role, loader, columns } = this.state;

    return (
      <LayoutWrapper 
        title="Assessment Management" 
        back=""
        headerRight={
          <div className="d-flex align-items-center gap-2">
            <label className="fw-bold mb-0 text-nowrap" style={{ fontSize: '13px' }}>Academic Year:</label>
            <div style={{ minWidth: '150px' }}>
              <select
                className="form-select"
                value={assessmentYear}
                onChange={(e) => this.setState({ assessmentYear: e.target.value }, () => this.fetchList())}
                style={{ fontSize: '13px', borderRadius: '0.25rem', borderColor: '#dee2e6', cursor: 'pointer', minHeight: '40px' }}
              >
                {academicYears.map((year) => (
                  <option key={year._id} value={year._id}>
                    {year.display_value}
                  </option>
                ))}
              </select>
            </div>
          </div>
        }
      >
        <AssessSearch api={this.props.api} onSearch={(searchData) => this.onSearch(searchData)} />
        <div className="row">
          <div className="col-12">
            <div className="card bg-white p-3">
              {!!data.length && (
                <AppTable
                  data={data}
                  columns={columns}
                  total={rowcount}
                  loading={loader}
                  onChange={(...arg) => this.onPageChange(...arg)}
                  isresponsive={true}
                  editable={false}
                  deletable={false}
                  viewable={false}
                  reorder={true}
                />
              )}
              {data.length === 0 && <div className="empty_layout_configureassessments"></div>}
            </div>
          </div>
        </div>
      </LayoutWrapper>
    );
  }
}

export default connect(AssessManagement);
